import { Helmet } from "react-helmet";
const LinkHead = ({
  title,

  content,
}: {
  title: string;

  content: string;
}) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name={"description"} content={content} />
      </Helmet>
    </>
  );
};

export default LinkHead;
